import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";
import { salesOrders } from "./sales-orders";
import { items, accounts, taxTemplates } from "../../accounting/schemas/public";

// ============================================================================
// sales_order_items — รายการในใบสั่งขาย
// ============================================================================
export const salesOrderItems = sqliteTable("sales_order_items", {
  id: text("id").primaryKey(), // ULID
  salesOrderId: text("sales_order_id").notNull().references(() => salesOrders.id), // FK -> sales_orders
  itemId: text("item_id").references(() => items.id), // FK -> items (nullable for manual entry)
  description: text("description"),
  qty: real("qty").notNull().default(1),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  deliveredQty: real("delivered_qty").notNull().default(0),
  deliveredAmount: real("delivered_amount").notNull().default(0),
  billedQty: real("billed_qty").notNull().default(0),
  billedAmount: real("billed_amount").notNull().default(0),
  accountId: text("account_id").references(() => accounts.id), // FK -> accounts (override item default)
  taxTemplateId: text("tax_template_id").references(() => taxTemplates.id), // FK -> tax_templates
  taxAmount: real("tax_amount").notNull().default(0),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  salesOrderIdx: index("soi_sales_order_idx").on(table.salesOrderId),
}));

// Type exports
export type SalesOrderItem = typeof salesOrderItems.$inferSelect;
export type NewSalesOrderItem = typeof salesOrderItems.$inferInsert;
